const CUI_INVALID = "CIF / CUI invalid";
const REGISTER_NUM_INVALID = "Nr. inregistrare invalid";
const COD_POSTAL_INVALID = "Cos postal invalid";
const ADDRESS_INVALID = "Adresa invalida";
const POSTAL_CODE_INVALID = "Cod postal invalid";
const CITY_INVALID = "Oras / sector invalid";
const COUNTY_INVALID = "Judet invalid";
const APPELLATIVE_INVALID = "Apelativ invalid";
const POSITION_INVALID = "Pozitia in cadrul companiei invalida";
const FIRST_NAME_INVALID = "Prenume invalid";
const LAST_NAME_INVALID = "Nume invalid";
const EMAIL_INVALID = "Email invalid";
const PHONE_INVALID = "Telefon invalid";
const IBAN_INVALID = "Cont IBAN invalid";
const BANK_INVALID = "Deschis la banca invalid";
const DATE_INVALID = "Data contractului invalid";
const AMOUNT_INVALID = "Suma din contract (lei) invalid";
const GENERAL_INVALID = "Camp invalid";

const INITIAL_LETTER_FATHER_INVALID = "Iinițiala tatălui invalida";
const STREET_INVALID = "Stradă invalida";
const NUMBER_INVALID = "Număr invalid";
const FLOOR_INVALID = "Etaj invalid";
const ENTRANCE_INVALID = "Scară invalida";
const APARTMENT_INVALID = "Apartament invalid";
const COUNTY_SECTOR_INVALID = "Județ/Sector invalid";
const BUILDING_INVALID = "Bloc invalid";
const LOCALITY_INVALID = "Localitate invalida";
const IDENTITY_NUMBER_INVALID = "Cod numeric personal / Număr de identificare fiscală invalid";
const SIGNATURE_INVALID = "Te rugam sa adaugi o semnatura";


export {
  SIGNATURE_INVALID,
  INITIAL_LETTER_FATHER_INVALID,
  STREET_INVALID,
  NUMBER_INVALID,
  FLOOR_INVALID,
  ENTRANCE_INVALID,
  APARTMENT_INVALID,
  COUNTY_SECTOR_INVALID,
  BUILDING_INVALID,
  LOCALITY_INVALID,
  IDENTITY_NUMBER_INVALID,
  POSITION_INVALID,
  FIRST_NAME_INVALID,
  LAST_NAME_INVALID,
  EMAIL_INVALID,
  PHONE_INVALID,
  IBAN_INVALID,
  BANK_INVALID,
  DATE_INVALID,
  AMOUNT_INVALID,
  CUI_INVALID,
  REGISTER_NUM_INVALID,
  COD_POSTAL_INVALID,
  ADDRESS_INVALID,
  POSTAL_CODE_INVALID,
  CITY_INVALID,
  COUNTY_INVALID,
  APPELLATIVE_INVALID,
  GENERAL_INVALID
};
